import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const Section = styled.div`
  width: inherit;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 20px 15px;
`;

export const ContainerLoading = styled.div`
  width: 100%;
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContainerCard = styled.div`
  border: 00.0625rem rgba(0, 0, 0, 0.125) solid;
  border-radius: 0.2rem;
  background-color: white;
  box-shadow: 0.05rem 0.05rem 0.5rem rgba(0, 0, 0, 0.125);
  padding: 20px;
`;
